// FE-LAYOUT-010 (2026-05-17): config compartilhada do dataZoom V+H dos
// GraficoSH/SM. Portado de Agro/WaterBalanceCulture/DetailedView/DVCard/
// DVChart/chartConfig.ts com ajuste para 1 chart por wrapper (yAxisIndex
// fixo em 0; Agro tem multiplos charts em sequencia).
import { BLACK_300, MEDIUM_BLUE } from 'constants/colors';

// Tipo opaco do option ECharts (mesmo padrao do helper/windx.ts).
export type EChartsDataZoom = Record<string, unknown>[];

/**
 * Constroi a config `dataZoom` para 1 chart com:
 *   - Entrada 0: zoom X (slider H externo controla `start`/`end` em %).
 *     `show: false` — sem barra visual do ECharts; quem renderiza eh o
 *     <DoubleSlider> DS abaixo.
 *   - Entrada 1: zoom Y (slider V visivel a direita, styled DS).
 *
 * @param zoomStart  X start em % (0..100)
 * @param zoomEnd    X end em % (0..100)
 * @param yAxisIndex eixo Y alvo do slider V (default 0). Charts Windx
 *                   usam 1 eixo Y; SH com `incluir_observado` pode ter 2 —
 *                   nesse caso passar [0, 1].
 */
export function getDataZoomConfig(
  zoomStart: number,
  zoomEnd: number,
  yAxisIndex: number | number[] = 0,
): EChartsDataZoom {
  return [
    {
      type: 'slider',
      show: false,
      xAxisIndex: 0,
      filterMode: 'none',
      start: zoomStart,
      end: zoomEnd,
    },
    {
      type: 'slider',
      show: true,
      yAxisIndex,
      // Valor fixo em px (vs `right: '5%'`) garante gap consistente entre
      // o slider e a borda direita do plot, independente da largura do
      // chart. Combinado com `grid.right: 80` no wrapper, o slider ocupa
      // o terco direito do gutter reservado.
      right: 32,
      start: 0,
      end: 100,
      filterMode: 'none',
      borderRadius: 32,
      width: 8,
      borderColor: BLACK_300, // tema: cor de dado (o ThemedECharts adapta)
      fillerColor: MEDIUM_BLUE, // tema: cor de dado (o ThemedECharts adapta)
      showDetail: false,
      showDataShadow: false,
      handleIcon: 'path://m50,50 a100,100 0 1,0 -200,0 a 100,100 0 1,0 200,0 Z',
      handleSize: 14,
      handleStyle: {
        borderColor: MEDIUM_BLUE, // tema: cor de dado (o ThemedECharts adapta)
        borderWidth: 2,
      },
      moveHandleStyle: {
        opacity: 0,
      },
      brushSelect: false,
    },
  ];
}
